import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import useIntl from 'useIntl';
import {
  SEARCH_SCRIPTS,
  GET_SCRIPT,
  GET_SCRIPTS,
} from '@control-front-end/common/constants/scripts';
import SelectEntityField from '../SelectEntityField';
import mes from './intl';

const initState = {
  list: [],
  limit: 15,
  offset: 0,
  endList: false,
  reqStatus: 'success',
};

/**
 * Поиск CDU скриптов
 */
function SelectCDUScript(props) {
  const t = useIntl();
  const dispatch = useDispatch();
  const [stateValue, setStateValue] = useState(props.value);
  const [scripts, setScripts] = useState(initState);

  useEffect(() => {
    const { value } = props;
    if (value && value.value && !value.title) {
      dispatch({
        type: GET_SCRIPT.REQUEST,
        payload: value.value,
        callback: (data) =>
          setStateValue({ value: data.id, title: data.title }),
      });
    }
  }, []);

  const getData = (loadMore = false) => {
    const localState = loadMore ? scripts : initState;
    dispatch({
      type: GET_SCRIPTS.REQUEST,
      payload: {
        loadMore,
        localState,
      },
      callback: (data) => setScripts(data),
    });
  };

  const clearData = () => {
    setScripts(initState);
  };

  /**
   * Обработка поискового запроса
   */
  const handleSearch = (query) => {
    if (!query.length) {
      getData();
      return;
    }
    if (query.length < 2) return;
    dispatch({
      type: SEARCH_SCRIPTS.REQUEST,
      payload: { query },
      callback: (data) => {
        setScripts({ ...initState, list: data });
      },
    });
  };

  return (
    <SelectEntityField
      bordered={true}
      autoFocus={true}
      resultLabel={t(mes.scripts)}
      placeholder={t(mes.searchScriptsByName)}
      objType="script"
      list={scripts.list}
      onSearch={handleSearch}
      onFocus={() => getData()}
      onBlur={() => clearData()}
      onScroll={() => getData(true)}
      value={stateValue}
      {...props}
    />
  );
}

SelectCDUScript.propTypes = {
  value: PropTypes.object,
};

export default SelectCDUScript;
